<template>
  <div class="col-lg-12 pb-4 border">
    <div class="card">
      <div class="card-body">
        <div v-if="target">
          <h4 class="card-title mb-4">
            <div class="row">
              <div class="col-4">
                <h6 class="text-muted mb-2">
                  <b>*{{ $t("telegram.example") }} :</b> 6285790422395 /
                  KangKuman
                </h6>
                <div class="input-group mt-2">
                  <input
                    id="search"
                    type="text"
                    class="form-control"
                    placeholder="phone number or username.."
                    v-model="searchKeyUsers"
                    aria-describedby="search"
                    v-on:input="removeSpace(searchKeyUsers)"
                    @keyup.enter="SearchUsersTele"
                  />
                  <div class="input-group-prepend">
                    <button
                      id="search"
                      class="input-group-text bg-primary text-white"
                      @click="SearchUsersTele"
                    >
                      <i class="bx bx-search-alt search-icon"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-8 text-right">
                <b-button
                  @click="refresh"
                  class="btn btn-sm p-0 px-1 mx-2"
                  variant="success"
                  v-if="
                    user_type === 'superadmin' ||
                    user_type === 'admin' ||
                    user_type === 'vvip'
                  "
                  ><i
                    :class="loading ? 'mdi-spin' : ''"
                    class="mdi mdi-18px mdi-refresh p-0"
                  ></i
                ></b-button>
              </div>
            </div>
          </h4>
          <!-- <h1>{{search_member_telegram}}</h1> -->
          <div class="hori-timeline">
            <cytoscape
              v-if="dataTelegram"
              ref="cyRef"
              :afterCreated="afterCreated"
              :preConfig="preConfig"
              :config="config"
              v-on:mousedown="addNode"
              @click="link"
              v-on:cxttapstart="updateNode"
            >
            </cytoscape>
            <div v-else class="row mt-5 mb-5 pb-4">
              <div class="text-center m-5 p-5 col-12">
                <b-spinner label="Loading..."></b-spinner>
                <br />
                loading..
              </div>
            </div>
          </div>
        </div>
        <div v-if="loadingnew" class="mt-4 mx-auto p-5">
          <div class="text-center">
            <div
              class="spinner-border text-secondary"
              role="status"
              v-if="loadingnew"
            >
              <span class="sr-only"
                ><p>{{ $t("website.website-info") }}</p></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import appConfig from "@/app.config";
import TargetService from "@/helpers/target-profile.service";
import PreferenceService from "@/helpers/preference.service.js";
import GroupService from "@/helpers/group.service.js";
import TwintService from "@/helpers/twint.service";
import cola from "cytoscape-cola";
import cola2 from "cytoscape-cola";
import noOverlap from "cytoscape-no-overlap";
import cytoscape from "cytoscape";

export default {
  props: ["user_type"],
  components: { Carousel, Slide },

  data() {
    var baseUrl = window.location.origin;
    return {
      key_id: this.$route.params.id,
      search_member_telegram: false,
      searchKeyUsers: "KangKuman",
      loading_search_users: false,
      search_users: false,
      error_users: "",
      baseUrl: baseUrl + "/project-overview/",
      loadingnew: false,
      dataRelation: false,
      dataWordCloud: false,
      dataFollow: false,
      dataTelegram: false,
      elastic: "",
      target: [],
      title: "Ontology",
      config: {
        layout: {
          name: "cola",
          animate: true,
          refresh: 5,
          maxSimulationTime: 10000,
          fit: true,
          randomize: true,
          avoidOverlap: true,
        },
        style: [
          {
            selector: "node[id='telegrup']",
            style: {
              width: "50px",
              height: "50px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#bf151c",
              "font-size": "14px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#bf151c",
              "text-outline-color": "#118bc4",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[parent_node='telegramgroup']",
            style: {
              width: "30px",
              height: "30px",
              content: "data(label)",
              "text-transform": "lowercase",
              color: "#555555",
              "font-size": "12px",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#118bc4",
              "text-outline-color": "#118bc4",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "edge[target='telegrup']",
            style: {
              width: 2,
              "line-color": "#bf151c",
              "target-arrow-color": "#F76300",
            },
          },
        ],
        elements: {
          nodes: [
            {
              data: {
                id: "telegrup",
                label: "TELEGRAM",
              },
            },
          ],
          edges: [],
        },
      },

      items: [
        {
          text: "galaxy",
          href: "/",
        },
        {
          text: "galaxy",
          active: true,
        },
      ],
      loading: false,
    };
  },
  methods: {
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.getGrupTelegram();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getGrupTelegram() {
      const name = "telegram";
      let sk = this.key_id.substring(0, 2);
      if (sk == "62") {
        var data_search = {
          size: 1000,
          query: {
            match: {
              "listmember.phone.keyword": this.key_id,
            },
          },
        };
      } else {
        var data_search = {
          size: 1000,
          query: {
            match: {
              "listmember.username.keyword": this.key_id,
            },
          },
        };
      }
      await // GroupService.getTelegramGroupElastic(this.elastic, name)
      GroupService.SearchGroupByPhone(this.elastic, data_search)
        .then((response) => {
          let listTelegram = response.data.hits.hits;
          // console.log('data', response.data.hits.hits);
          this.config.elements.nodes = [
            {
              data: {
                id: "telegrup",
                label: this.key_id,
              },
            },
          ];

          listTelegram.forEach((val, index) => {
            // console.log('val', val);
            const data_top_nodes = {
              data: {
                id: "top-" + index,
                label: val._id,
                parent_node: "telegramgroup",
              },
              username: this.key_id,
            };
            if (this.key_id) {
              this.config.elements.nodes.push(data_top_nodes);
              const data_top_edges = {
                data: {
                  source: "top-" + index,
                  target: "telegrup",
                },
              };
              this.config.elements.edges.push(data_top_edges);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
      this.dataTelegram = true;
    },

    addNode(event) {
      // var node = event.target;
      // var type = node.data('parent_node');
      // console.log(type);
    },

    SearchUsersTele() {
      // console.log(this.searchKeyUsers);
      window.location.replace("/galaxy-search/" + this.searchKeyUsers);
    },

    link(event) {
      var node = event.target;
      var type = node.data("parent_node");
      var key = node.data("username");
      var id_target = node.data("id_target");
      if (type == "telegram") {
        this.$router.push("group-telegram/view/" + key);
      }
    },

    deleteNode(id) {
      // console.log("node clicked", id);
    },

    updateNode(event) {
      console.log("right click node", event);
    },
    preConfig(cytoscape) {
      cytoscape.use(cola);
    },
    preConfig2(cytoscape2) {
      cytoscape2.use(cola2);
    },
    async afterCreated(cy = null) {
      if (cy !== null) {
        this.cy = cy;
      } else {
        cy = this.cy;
      }
      await cy;
      cy.load;
      cy.userZoomingEnabled(false);
      cy.layout(this.config.layout).run();
      cy.add();
    },
    refresh() {
      this.loading = true;
      this.afterCreated();

      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    removeSpace(value) {
      let hsl = value.replace(/\s/g, "");
      return (this.searchKeyUsers = hsl);
    },
  },

  filters: {
    upper(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    lower(value) {
      if (!value) return "";
      value = value.toString();
      return value.toLowerCase();
    },
  },
  beforeMount() {
    this.getPreferences();
  },
  mounted() {
    this.searchKeyUsers = this.$route.params.id;
  },
};
</script>
